"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const ECategorieSocialProfessionnel_1 = require("../../enums/ClientSheet/ECategorieSocialProfessionnel");
const ECivility_1 = require("../../enums/ClientSheet/ECivility");
const ELegalCapacity_1 = require("../../enums/ClientSheet/ELegalCapacity");
const ECountry_1 = require("../../enums/Country/ECountry");
const ValidationErrors_1 = require("../../enums/Validation/ValidationErrors");
const AddressCreateRequestResource_1 = __importDefault(require("../Address/AddressCreateRequestResource"));
const Custom_1 = __importDefault(require("../decorators/Custom"));
const Resource_1 = __importDefault(require("../Resource"));
class ClientSheetCreateBeneficiaryRequestResource extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.civility = ECivility_1.ECivility.non_communique;
        this.politicallyExposed = false;
        this.personUS = false;
        this.email = null;
        this.mobilePhone = null;
        this.profession = null;
        this.lineOfBusiness = null;
        this.categorieSocialProfessionnel = null;
    }
}
exports.default = ClientSheetCreateBeneficiaryRequestResource;
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(ECivility_1.ECivility),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateBeneficiaryRequestResource.prototype, "civility", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateBeneficiaryRequestResource.prototype, "lastName", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((obj) => {
        if (obj.civility === ECivility_1.ECivility.madame)
            return true;
        obj.maidenName = null;
        return false;
    }),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ClientSheetCreateBeneficiaryRequestResource.prototype, "maidenName", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], ClientSheetCreateBeneficiaryRequestResource.prototype, "firstName", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, Custom_1.default)((value) => new Date(value) < new Date(), { message: ValidationErrors_1.EValidationError.mustBeInThePast }),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], ClientSheetCreateBeneficiaryRequestResource.prototype, "birthDate", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(60),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateBeneficiaryRequestResource.prototype, "birthPlace", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsNumberString)({ no_symbols: true }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateBeneficiaryRequestResource.prototype, "birthDepartment", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(ECountry_1.ECountry),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateBeneficiaryRequestResource.prototype, "birthCountry", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(ECountry_1.ECountry),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateBeneficiaryRequestResource.prototype, "nationality", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(60),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateBeneficiaryRequestResource.prototype, "nif", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(ECountry_1.ECountry),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateBeneficiaryRequestResource.prototype, "taxResidenceCountry", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(ELegalCapacity_1.ELegalCapacity),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateBeneficiaryRequestResource.prototype, "legalCapacity", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], ClientSheetCreateBeneficiaryRequestResource.prototype, "politicallyExposed", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsBoolean)(),
    (0, Custom_1.default)((value) => value === false, { message: ValidationErrors_1.EValidationError.personUSmustBeFalse }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], ClientSheetCreateBeneficiaryRequestResource.prototype, "personUS", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], ClientSheetCreateBeneficiaryRequestResource.prototype, "agreementElectronicDocument", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => AddressCreateRequestResource_1.default),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", AddressCreateRequestResource_1.default)
], ClientSheetCreateBeneficiaryRequestResource.prototype, "address", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.Min)(0, { context: [0] }),
    (0, class_validator_1.Max)(100, { context: [100] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ClientSheetCreateBeneficiaryRequestResource.prototype, "pourcentageParts", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEmail)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ClientSheetCreateBeneficiaryRequestResource.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumberString)({ no_symbols: false }),
    (0, class_validator_1.IsPhoneNumber)("FR"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ClientSheetCreateBeneficiaryRequestResource.prototype, "mobilePhone", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.MaxLength)(60),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ClientSheetCreateBeneficiaryRequestResource.prototype, "profession", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.MinLength)(1, { context: [1] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ClientSheetCreateBeneficiaryRequestResource.prototype, "lineOfBusiness", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(ECategorieSocialProfessionnel_1.ECategorieSocialProfessionnel),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ClientSheetCreateBeneficiaryRequestResource.prototype, "categorieSocialProfessionnel", void 0);
